import { useMemo } from 'react'
import PropTypes from 'prop-types'

import { useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'

import CreateOrEditCustomFieldModal from '@modals/CreateOrEditCustomFieldModal'
import CreateOrEditCustomFieldSetModal from '@modals/CreateOrEditCustomFieldSetModal'

import PageContent from './components/PageContent'

const callbacks = (component, setState) => {
  const componentCallbacks = {
    CreateOrEditCustomFieldModal: {
      closeModal: () => setState({ showCreateOrEditCustomFieldModal: false }),
      createCustomField: payload => handleCallbackAction(payload),
      deleteCustomField: payload => handleCallbackAction(payload),
      updateCustomField: payload => handleCallbackAction(payload),
    },
    CreateOrEditCustomFieldSetModal: {
      closeModal: () => setState({ showCreateOrEditCustomFieldSetModal: false }),
      createCustomFieldSet: payload => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreateOrEditCustomFieldModal: false,
  showCreateOrEditCustomFieldSetModal: false,
}

const CustomFields = (props) => {
  const { brandId } = props

  const [state, setState] = useSetState(defaultState)
  const { showCreateOrEditCustomFieldModal, showCreateOrEditCustomFieldSetModal } = state

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      deleteCustomField: payload => handleCallbackAction(payload),
      showCreateOrEditCustomFieldModal: (payload) => {
        setModalData('CreateOrEditCustomFieldModal', payload)
        setState({ showCreateOrEditCustomFieldModal: true })
      },
      showCreateOrEditCustomFieldSetModal: (payload) => {
        setModalData('CreateOrEditCustomFieldSetModal', payload)
        setState({ showCreateOrEditCustomFieldSetModal: true })
      },
      updateBrand: payload => handleCallbackAction(payload),
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent brandId={brandId} />

        <CreateOrEditCustomFieldModal
          callbacks={callbacks('CreateOrEditCustomFieldModal', setState)}
          showModal={showCreateOrEditCustomFieldModal}
        />

        <CreateOrEditCustomFieldSetModal
          callbacks={callbacks('CreateOrEditCustomFieldSetModal', setState)}
          showModal={showCreateOrEditCustomFieldSetModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

CustomFields.propTypes = {
  brandId: PropTypes.number.isRequired,
}

export default CustomFields
